import React from 'react';
import PropTypes from 'prop-types';
import { generateBlockList } from '../components/BlockList/BlockList.js';

var WPBlock = function WPBlock(_ref) {
  var index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, generateBlockList({
    blocks: innerBlocks
  }));
};
WPBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var WPBlock$1 = WPBlock;

export { WPBlock$1 as default };
